/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import styles from './DriverTermsAcceptToggle.module.css';

const DRIVER_TERMS_PATH = '/contract';

export default function DriverTermsAcceptToggle({ checked, onChange, id = 'driver-terms-accept' }) {
  return (
    <label className={styles.row} htmlFor={id}>
      <span className={styles.switchWrap}>
        <input
          id={id}
          type="checkbox"
          className={styles.toggleInput}
          checked={checked}
          onChange={event => onChange(event.target.checked)}
        />
        <span className={styles.switch} aria-hidden="true" />
      </span>
      <span className={styles.label}>
        <Trans
          i18nKey="driverTermsAccept.label"
          components={{
            termsLink: <Link to={DRIVER_TERMS_PATH} className={styles.link} />,
          }}
        />
      </span>
    </label>
  );
}
